import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'BillSendRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'BillSendRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'BillSendRecord',
    column_type: 'datetime',
  },
  customer: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  sender: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sender',
      model_name: 'User',
    },
  },
  sender_id: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'sender',
      model_name: 'User',
    },
  },
  send_method: {
    model_name: 'BillSendRecord',
    column_type: 'string',
  },
  sent_at: {
    model_name: 'BillSendRecord',
    column_type: 'datetime',
  },
  state: {
    model_name: 'BillSendRecord',
    column_type: 'enum',
  },
  confirmed_at: {
    model_name: 'BillSendRecord',
    column_type: 'datetime',
  },
  confirmed_by: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'confirmed_by',
      model_name: 'User',
    },
  },
  confirmed_by_id: {
    model_name: 'BillSendRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'confirmed_by',
      model_name: 'User',
    },
  },
  confirmed_ip: {
    model_name: 'BillSendRecord',
    column_type: 'string',
  },
  file: {
    model_name: 'BillSendRecord',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  can_confirm: {
    model_name: 'BillSendRecord',
    column_type: 'string',
  },
  can_reopen: {
    model_name: 'BillSendRecord',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
